// extracted by mini-css-extract-plugin
export default {"melodyVideo":"CK-z","isFullWidth":"DK-z","landingPageVideo":"EK-z","play":"FK-z","iframeVideo":"GK-z","playHidden":"HK-z","fullwidth":"IK-z"};